export function QuestionTranslatePlaceholder() {
  return (
    <div className="flex min-h-34 flex-col items-center justify-center space-y-4 opacity-80">
      <p className="text-text-tertiary text-center text-sm">Przesuń lub kliknij słowa z listy poniżej, aby utworzyć zdanie.</p>
      <div className="flex flex-wrap items-center justify-center gap-2 opacity-40">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="border-border-primary flex h-8 min-w-16 items-center justify-center rounded-full border-2 border-dashed bg-transparent px-3">
            <div className="bg-fill-gray h-1 w-8 rounded-full" />
          </div>
        ))}
      </div>
      <div className="text-text-tertiary text-center text-xs">↑ Upuść tutaj, aby utworzyć zdanie</div>
    </div>
  );
}
